import type { MouseEvent } from "react";

const footerGroups = [
  {
    title: "快速入口",
    links: [
      { label: "事件时间线", href: "#timeline" },
      { label: "全盘点合集", href: "#events" },
      { label: "人气热议榜", href: "#ranking" },
      { label: "图文档案馆", href: "#gallery" },
    ],
  },
  {
    title: "还没看够",
    links: [
      { label: "常见疑问", href: "#faq" },
      { label: "更新提醒", href: "#subscribe" },
      { label: "回到顶部", href: "#top" },
    ],
  },
];

export default function SiteFooter() {
  const handleAnchor = (event: MouseEvent<HTMLAnchorElement>, hash: string) => {
    event.preventDefault();
    const target = document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="bg-primary-900 text-background-50/85">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr] md:gap-12">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-bold text-primary-700">
                灵
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold tracking-wide text-background-50">灵灵黑料</span>
                <span className="mt-1 font-label text-[10px] tracking-[0.22em] text-background-50/60">
                  事件汇总 · 时间线档案
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-50/70">
              一个把零散信息重新排好序的聚合页：灵灵黑料事件汇总、全盘点与时间线大合集都收在这里，为的是让你把来龙去脉一次看明白。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{group.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(event) => handleAnchor(event, link.href)}
                      className="cursor-pointer whitespace-nowrap font-label text-sm text-background-50/70 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-50/60">© 2026 灵灵黑料 · 本页仅为信息聚合与时间线整理展示</p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex cursor-pointer items-center gap-2 self-start rounded-md border border-background-50/25 px-3.5 py-2 font-label text-xs text-background-50/80 transition-colors hover:border-accent-400 hover:text-accent-400 sm:self-auto"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}